import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';
import { ProblemDetails } from '@platform/shared/http/problem-details';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { PreComponent } from '../pre/pre.component';

export interface ErrorSnackbarData {
  message?: string;
  messageT?: string;
  messageTParams?: object;
  problemDetail: ProblemDetails;
}

@Component({
  selector: 'app-error-snackbar',
  standalone: true,
  imports: [
    NgIf,
    MatButtonModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
    MatButtonModule,
    MatExpansionModule,
    PreComponent,
    TranslateModule,
  ],
  templateUrl: './error-snackbar.component.html',
  styleUrl: './error-snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
  data = inject<ErrorSnackbarData>(MAT_SNACK_BAR_DATA);
  translate = inject(TranslateService);

  get message() {
    if (this.data.message) {
      return this.data.message;
    }

    if (this.data.messageT) {
      return this.translate.instant(this.data.messageT, this.data.messageTParams);
    }

    return 'Error occured. Message was not specified.';
  }

  // private _snackBar = inject(MatSnackBar);

  // durationInSeconds = 5;

  // openSnackBar() {
  //   this._snackBar.openFromComponent(PizzaPartyAnnotatedComponent, {
  //     duration: this.durationInSeconds * 1000,
  //   });
  // }
}
